import { FIELDS } from "./fields";

export const MATRIX_TABLE_COLUMNS = [
    { id: FIELDS.matrixCode.key, label: FIELDS.matrixCode.name },
    { id: FIELDS.description.key, label: FIELDS.description.name },
    { id: FIELDS.accountTypeId.key, label: FIELDS.accountTypeId.name },
    { id: FIELDS.officeId.key, label: FIELDS.officeId.name },
    { id: FIELDS.active.key, label: FIELDS.state.name },
]